import { useState, useRef } from "react";
import axios from "axios";
import { API, authHeaders, mediaUrl, errMsg } from "@/lib/galleryApi";
import { createEngine, exportHD } from "@/lib/photoEngine";

// Renders originals at full resolution in the browser (GPU) and uploads the JPEG HD + web/thumbnail versions
export function useBatchExport(onDone) {
  const [state, setState] = useState({ running: false, total: 0, done: 0, current: null, errors: [] });
  const engineRef = useRef(null);
  const canvasRef = useRef(null);
  const cancelRef = useRef(false);

  const engine = () => {
    if (!engineRef.current) {
      canvasRef.current = document.createElement("canvas");
      engineRef.current = createEngine(canvasRef.current);
    }
    return engineRef.current;
  };

  const exportOne = async (photo) => {
    const adj = photo.adjustments || {};
    const out = await exportHD(engine(), canvasRef.current, mediaUrl(photo.original_url), adj);
    const form = new FormData();
    form.append("file", out.full, "export.jpg");
    form.append("web", out.web, "web.jpg");
    form.append("thumb", out.thumb, "thumb.webp");
    form.append("adjustments", JSON.stringify(adj));
    form.append("width", out.width);
    form.append("height", out.height);
    const res = await axios.post(`${API}/api/galleries/photos/${photo.id}/processed`, form, { headers: authHeaders() });
    return { ...res.data, limited: out.limited };
  };

  const run = async (photos) => {
    cancelRef.current = false;
    const errors = [];
    setState({ running: true, total: photos.length, done: 0, current: null, errors });
    for (const p of photos) {
      if (cancelRef.current) break;
      setState((s) => ({ ...s, current: p.filename }));
      try {
        onDone(await exportOne(p));
      } catch (e) {
        errors.push({ name: p.filename, error: errMsg(e, "Echec export") });
      }
      setState((s) => ({ ...s, done: s.done + 1, errors: [...errors] }));
    }
    setState((s) => ({ ...s, running: false, current: null }));
    return errors;
  };

  return { ...state, run, exportOne, cancel: () => { cancelRef.current = true; }, reset: () => setState({ running: false, total: 0, done: 0, current: null, errors: [] }) };
}
